export default __webpack_public_path__ + "static/media/who-never-do-1.16262e07.png";